import React, { createContext, ReactNode, useContext, useEffect, useState } from "react"
import { Alert, Box } from "@strapi/design-system"

interface AlertData {
  error: boolean
  text: string | ReactNode
}

interface AlertContextType {
  showAlert: (alert: AlertData) => void
}

const AlertContext = createContext<AlertContextType | undefined>(undefined)

export const AlertProvider = ({ children }: { children: ReactNode }) => {
  const [alert, setAlert] = useState<AlertData | null>(null)

  useEffect(() => {
    if (alert) {
      const timer = setTimeout(() => setAlert(null), 3000)
      return () => clearTimeout(timer)
    }
  }, [alert])

  const showAlert = (alertData: AlertData) => {
    setAlert(alertData)
  }

  return (
    <AlertContext.Provider value={{ showAlert }}>
      <Box style={{ position: "relative", height: "100vh" }}>
        {alert && (
          <Box style={{ width: "100%", position: "absolute", zIndex: 100 }} padding={10}>
            <Alert variant={alert.error ? "danger" : "success"} onClose={() => setAlert(null)}>
              {alert.text}
            </Alert>
          </Box>
        )}
        {children}
      </Box>
    </AlertContext.Provider>
  )
}

export const useAlert = () => {
  const context = useContext(AlertContext)
  if (!context) throw new Error("useAlert must be used within an AlertProvider")

  return context
}
